<template>
  <div id="knowledge-base">
    <v-row>
      <v-col cols="12" md="3" lg="3" order="1" order-md="2" class="knowledge-base-summary-overlay">
        <v-card class="knowledge-base-summary">
          <div class="kb-questions py-1">
            <div
              v-for="subTitle in merchantoEventsSummary"
              :key="subTitle.title"
              class="kb-question d-flex align-start text-sm px-5 my-4 cursor-pointer"
            >
              <v-icon size="14" class="me-2 mt-1" color="secondary">
                {{ icons.mdiCheckboxBlankCircleOutline }}
              </v-icon>
              <span class="text--secondary" @click="scrollToElement(subTitle.link)">{{ subTitle.title }}</span>
            </div>
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" md="9" lg="9" order="1" order-md="2">
        <v-card>
          <EventsHandleEventsDocumentationV2 />
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mdiCogOutline, mdiCheckboxBlankCircleOutline, mdiCellphoneCog, mdiChevronLeft } from '@mdi/js';
import useDocs from '@/views/docs/useDocs';
import { ref } from '@vue/composition-api';
import EventsHandleEventsDocumentationV2
  from '@/views/docs/chargebacks/merchanto-events-documentation/EventsHandleEventsDocumentationV2';

export default {
  components: { EventsHandleEventsDocumentationV2 },
  setup() {
    const { scrollToElement } = useDocs();
    const tab = ref(null);

    const merchantoEventsSummary = [
      { title: 'Overview', link: 'overview' },
      { title: 'API Workflow', link: 'api-workflow' },
      { title: '1. Getting Started', link: 'getting-started' },
      { title: '1.1. Authentication', link: 'authentication' },
      { title: '1.2. Environments', link: 'environments' },
      { title: '1.3. Client Endpoints', link: 'client-endpoints' },
      { title: '1.4. Integration Testing', link: 'integration-testing' },
      { title: '1.5. HTTP Status Codes', link: 'http-status-codes' },
      { title: '1.6. Event Statuses', link: 'event-statuses' },
      { title: '2. Receiving Events (Webhooks)', link: 'receiving-events' },
      { title: '2.1. Push Event Data', link: 'push-event-data' },
      { title: '2.2. Status Update Notification', link: 'status-update-notification' },
      { title: '2.3. Retry Logic', link: 'retry-logic' },
      { title: '3. Updating Event Status', link: 'updating-event-status' },
      { title: '3.1. Endpoint Details', link: 'endpoint-details' },
      { title: '3.2. Request Payload', link: 'request-payload' },
      { title: '3.3. Response Examples', link: 'response-examples' },
      { title: '4. Retrieving Events', link: 'retrieving-events' },
      { title: '4.1. Get All Events', link: 'get-all-events' },
      { title: '4.2. Get Event by eventId', link: 'get-event-by-eventid' },
      { title: '5. Detailed Object Schemas', link: 'detailed-object-schemas' },
      { title: '5.1. Event Object', link: 'event-object' },
      { title: '5.2. Website Object', link: 'website-object' },
      { title: '5.3. Outcome Object', link: 'outcome-object' },
      { title: '6. Migration Guide (V1 to V2)', link: 'migration-guide' },
      { title: '6.1. Overview', link: 'migration-overview' },
      { title: '6.2. Field Changes', link: 'field-changes' },
      { title: '6.3. Status Simplification', link: 'status-simplification' },
      { title: '6.4. Migration Steps', link: 'migration-steps' },
    ];

    return {
      merchantoEventsSummary,
      icons: {
        mdiCogOutline,
        mdiCheckboxBlankCircleOutline,
        mdiCellphoneCog,
        mdiChevronLeft,
      },
      scrollToElement,
      tab,
    };
  },
};
</script>

<style lang="scss">
@import '@core/preset/preset/pages/knowledge-base.scss';
</style>
